import { BasicCustomCursor } from "@goodgamestudios/core";
import { Mouse, MouseCursor } from "@goodgamestudios/createjs-utilities";
import { MouseCursorData } from "@goodgamestudios/createjs-utilities";

import BitmapData = createjs.BitmapData;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class Poker2CustomCursor extends BasicCustomCursor {

    private currentCursorType: number = 0;
    private prevCursorType: number = 0;

    constructor() {
        super(new MovieClip);
    }

		/*override*/ public init(): void {
        super.init();

        this.disp.mouseChildren = false;
        this.disp.mouseEnabled = false;
        this.isEnabled = true;

        this.registerCursors();
    }

    private registerCursors(): void {
        this.addMouseCursor(BasicCustomCursor.CURSOR_ARROW, new Library.PokerInterface.CursorArrow());
        this.addMouseCursor(BasicCustomCursor.CURSOR_CLICK, new Library.PokerInterface.CursorClick());
        this.addMouseCursor(BasicCustomCursor.CURSOR_DRAG, new Library.PokerInterface.CursorDrag());
        this.addMouseCursor(BasicCustomCursor.CURSOR_HAND, new Library.PokerInterface.CursorActive());
        this.addMouseCursor(BasicCustomCursor.CURSOR_ZOOM, new Library.PokerInterface.CursorZoom());
    }

    private addMouseCursor(cursorType: number, bitmapData: BitmapData): void {
        var cursorData: MouseCursorData = new MouseCursorData();
        cursorData.data = [];
        cursorData.data[0] = bitmapData;

        Mouse.instance().registerCursor(this.typeToString(cursorType), cursorData);
    }

    private typeToString(cursorType: number): string {
        switch (cursorType) {
            case BasicCustomCursor.CURSOR_CLICK:
                return MouseCursor.CLICK;
            case BasicCustomCursor.CURSOR_DRAG:
                return MouseCursor.DRAG;
            case BasicCustomCursor.CURSOR_HAND:
                return MouseCursor.HAND;
            case BasicCustomCursor.CURSOR_ZOOM:
                return "zoom";
            default: //CURSOR_ARROW
                return MouseCursor.ARROW;
        }
    }

		/*override*/ public setCursorType(cursorType: number): void {
        if (this.currentCursorType != BasicCustomCursor.CURSOR_ARROW && cursorType == BasicCustomCursor.CURSOR_ARROW)
            var bla: number = 0;

        this.showCustomCursor();
        if (this.isEnabled) {
            this.prevCursorType = this.currentCursorType;
            this.currentCursorType = cursorType;

            Mouse.instance().showCustomCursor(this.typeToString(cursorType));
        }
    }

    public setPreviousCursorType(): void {
        this.setCursorType(this.prevCursorType);
    }

		/*override*/ public hideCustomCursor(): void {
        Mouse.instance().hideCustomCursor();
        this.additionalCursorGfx.visible = false;
    }

		/*override*/ public showCustomCursor(): void {
        this.additionalCursorGfx.visible = false;
        Mouse.instance().showCustomCursor(this.typeToString(this.currentCursorType));
    }

}
